import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommunicationsComponent } from './communications.component';
import { NgxMapModule } from 'src/app/modules/ngx-map/ngx-map.module';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CommunicationsTableComponent } from './components/communications-table/communications-table.component';
import { CommunicationInfoModalComponent } from './components/communication-info-modal/communication-info-modal.component';
import { CommunicationEmailComponent } from './components/communication-email/communication-email.component';
import { CommunicationLogFilterPipe } from './pipes/communication-log-filter.pipe';
import { LoadingModule } from 'src/app/components/loading/loading.module';

@NgModule({
  declarations: [CommunicationsComponent, CommunicationsTableComponent, CommunicationInfoModalComponent, CommunicationEmailComponent, CommunicationLogFilterPipe],
  imports: [
    CommonModule,
    RouterModule.forChild([
      { path: 'communications', component: CommunicationsComponent }
    ]),
    NgxMapModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    LoadingModule
  ]
})
export class CommunicationsModule { }
